import TechnicalUserRestService from './TechnicalUserRestService'
import { TFunction } from 'i18next'
import AppRestService from '../../../gateway/rest/AppRestService'

class TechnicalUserService {
  private static async updateAppConfiguration(appId: number, technicalUser: any) {
    if (technicalUser.id) {
      const appConfiguration = await AppRestService.getById(appId)

      appConfiguration.technicalUser = technicalUser.username
      appConfiguration.technicalUserPassword = technicalUser.password

      if (!appConfiguration.logindns) {
        appConfiguration.logindns = technicalUser.loginHost
      }

      await AppRestService.update(appConfiguration)
    }
  }

  static async createTechnicalUser(technicalUser: any, appId: number, t: TFunction) {
    try {
      const createdUser = await TechnicalUserRestService.create(technicalUser)
      await TechnicalUserService.updateAppConfiguration(appId, createdUser)
    } catch (error) {
      return Promise.reject(error)
    }
  }
}

export default TechnicalUserService
